import { isAxiosError } from "axios";

/**
 * Текст ошибки сервера для уведомления: первая ошибка валидации (422) или message.
 * Бизнес-правила заказа (статус, Lieferkondition, перепоставка) приходят именно так.
 */
export const serverErrorMessage = (error: unknown, fallback: string) => {
  if (!isAxiosError(error)) {
    return fallback;
  }
  const errors = error.response?.data?.errors as
    | Record<string, string[]>
    | undefined;
  const first = errors ? Object.values(errors)[0]?.[0] : undefined;

  return first ?? error.response?.data?.message ?? fallback;
};
